import Api from "../../axios";

export default async function apiShowCompOffList({ employee_id }) {
  return await Api.get(`/show_compoff_list?employee_id=${employee_id}`);
}
